'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var Button = require('@narvar/nth-block-button');
var TextInput = require('@narvar/nth-block-text-input');
var Checkbox = require('@narvar/nth-block-checkbox');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var types = require('../../../types.js');
var EmailOptInForm_module = require('./EmailOptInForm.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);
var Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(Checkbox);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const EmailOptIn = ({
  onOptIn,
  featureName,
  validationError,
  layout,
  notificationPreferencesState
}) => {
  const {
    preferenceLevel
  } = notificationPreferencesState || {};
  const [retailerLevelChecked, setRetailerLevelChecked] = React.useState(preferenceLevel === types.PreferenceLevels.RETAILER);
  const [email, setEmail] = React.useState('');
  const {
    retailerLevelOptInEnabled,
    retailerName
  } = nthHookGlobalSettings.useGlobalSettings();
  const {
    bodytextDefaultNone: bodyTextStyle,
    captiontextErrorNone: errorTextStyle
  } = nthHookTheme.useTheme();
  const {
    notificationCenterEmailInputLabel,
    notificationCenterEmailSignupButton,
    notificationCenterEmailValidationErrorMessage,
    notificationCenterRetailerLevelSubscribeOption
  } = nthHookTranslations.useTranslations();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const isLandscape = layout === FeatureLayout.LANDSCAPE;
  return /*#__PURE__*/React__default["default"].createElement("form", {
    noValidate: true,
    onSubmit: e => {
      e.preventDefault();
      logEvent({
        clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.EMAIL_SIGNUP,
        clickNotificationIsOptIn: true,
        clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.EMAIL_SIGNUP,
        clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
        eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_EMAIL_NOTIFICATION_CENTER,
        eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_EMAIL_NOTIFICATION_CENTER,
        eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
        feature: featureName,
        pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_EMAIL_NOTIFICATION_CENTER
      });
      onOptIn(email, retailerLevelChecked);
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: EmailOptInForm_module["default"].emailOptinFormContainer
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": `column-one-${isLandscape ? '7' : '12'}`,
    style: {
      gridColumn: `span ${isLandscape ? '7' : '12'}`,
      marginBottom: isLandscape ? '1rem' : undefined
    }
  }, /*#__PURE__*/React__default["default"].createElement(TextInput__default["default"], {
    id: notificationCenterEmailInputLabel || '',
    label: notificationCenterEmailInputLabel || '',
    animateLabel: true,
    title: notificationCenterEmailInputLabel || '',
    centered: !isLandscape,
    error: validationError,
    onChange: e => setEmail(e.target.value),
    featureName: featureName,
    containerOverridesStyle: validationError ? {
      border: `1px solid ${errorTextStyle?.color ?? ''}`
    } : undefined
  }), validationError && /*#__PURE__*/React__default["default"].createElement("div", {
    "data-test": "emailOptInValidationErrorContainer",
    style: {
      ...bodyTextStyle,
      ...errorTextStyle
    }
  }, notificationCenterEmailValidationErrorMessage), retailerLevelOptInEnabled && (preferenceLevel === types.PreferenceLevels.RETAILER || preferenceLevel === types.PreferenceLevels.ORDER) && /*#__PURE__*/React__default["default"].createElement(Checkbox__default["default"], {
    id: "retailerLevel",
    onChange: () => setRetailerLevelChecked(!retailerLevelChecked),
    featureName: featureName,
    checked: retailerLevelChecked,
    containerStyle: {
      marginTop: '1rem'
    },
    labelTextCellStyle: {
      textAlign: 'left'
    }
  }, mustache__default["default"].render(notificationCenterRetailerLevelSubscribeOption || '', {
    retailerName
  }))), /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": `column-two-${isLandscape ? '5' : '12'}`,
    style: {
      gridColumn: `span ${isLandscape ? '5' : '12'}`
    }
  }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    featureName: featureName,
    big: true,
    type: Button.ButtonType.submit
  }, notificationCenterEmailSignupButton))));
};
var EmailOptInForm = nthHookGlobalSettings.withGlobalSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(EmailOptIn, {
  themeTokens: ['bodytextDefaultNone', 'captiontextErrorNone']
}), {
  translationKeys: ['notificationCenterEmailInputLabel', 'notificationCenterEmailSignupButton', 'notificationCenterEmailValidationErrorMessage', 'notificationCenterRetailerLevelSubscribeOption']
}), {
  globalSettingsRequested: `
      retailerLevelOptInEnabled
      retailerName
    `
});

exports["default"] = EmailOptInForm;
